import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';
import { AdminDocumentFormValues, IAdminDocument } from '../models/AdminDocument';

const LIMIT = 50;

export default class AdminDocumentStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.page = 0;
                this.AdminDocumentRegistry.clear();
                this.loadAdminDocuments();
            }
        )
    }

    AdminDocumentRegistry = new Map();
    AdminDocument: IAdminDocument | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";

    AdminDocumentCount = 0;
    page = 0;

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.page ? this.page * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }

    get totalPages() {
        return Math.ceil(this.AdminDocumentCount / LIMIT);
    }

    setPage = (page: number) => {
        this.page = page;
    }

    get AdminDocumentsByOrder() {
        return Array.from(this.AdminDocumentRegistry.values()).sort(
            (a, b) => a.order - b.order
        );
    };



    loadAdminDocuments = async () => {
        this.loadingInitial = true;
        try {
            const AdminSettingEnvelope = await agent.AdminDocument.list(this.axiosParams);
            const { documentsDTO, documentCount } = AdminSettingEnvelope;

            runInAction('loadAdminSettings', () => {
                documentsDTO.forEach((documentDTO) => {
                    this.AdminDocumentRegistry.set(documentDTO.id, documentDTO);
                });
                this.AdminDocumentCount = documentCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadAdminSettings', () => {
            this.loadingInitial = false;
        });
    };

    getAdminDocument = (id: string) => {
        return this.AdminDocumentRegistry.get(id);
    }

    ClearAdminDocument = () => {
        this.AdminDocument = null;
    }

    createAdminDocument = async (adminDocument: AdminDocumentFormValues) => {
        this.submitting = true;
        try {
            const newId = await agent.AdminDocument.create(adminDocument);
            await this.loadAdminDocuments();
            toast.success('Saved');
            runInAction('createAdminDocument', () => {
                this.submitting = false;
                this.rootStore.modalStore.closeModal();
            });
        } catch (error) {
            runInAction('createAdminDocument error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editAdminDocument = async (adminDocument: AdminDocumentFormValues) => {
        this.submitting = true;
        try {
            await agent.AdminDocument.update(adminDocument);
            runInAction('editAdminDocument', () => {
                this.submitting = false;
            });
            toast.success('Saved');
            this.AdminDocumentRegistry.set(adminDocument.id, adminDocument);
            this.rootStore.modalStore.closeModal();
        } catch (error) {
            runInAction('editAdminDocument error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };



}
decorate(AdminDocumentStore, {
    AdminDocumentRegistry: observable,
    AdminDocument: observable,
    loadingInitial: observable,
    submitting: observable,
    target: observable,
    AdminDocumentCount: observable,
    page: observable,
    predicate: observable,

    loadAdminDocuments: action,
    ClearAdminDocument: action,
    setPredicate: action,
    setPage: action,
    createAdminDocument: action,
    editAdminDocument: action,

    AdminDocumentsByOrder: computed,
    axiosParams: computed,
    totalPages: computed
});